export const Auth = {
    LOGIN: "auth.login",
    SETUP_BEFORE_LOGIN: "auth.before_login",
    LOGOUT: "auth.logout",
    SIGNUP: "auth.signup",
    SET_SIGNUP: "auth.set_signup",
    LOGIN_ERROR: "auth.login_error",
    CLEAR_LOGIN_ERROR: "auth.clear_login_error",
    LOGOUT_ERROR: "auth.logout_error",
    SIGNUP_ERROR: "auth.signup_error",
    CLEAR_SIGNUP_ERROR: "auth.clear_signup_error",
    SET_VIEW: "auth.set_view",
    INIT: "auth.init",
    ERROR: "auth.error",
    CLEAN_SIGNUP: "auth.clean_signup",
    IS_READY: "auth.is_ready",
    APP_READY: "auth.app_ready",
    APP_NOT_READY: "auth.app_not_ready",
    // Login-pipeline readiness is the AND of two independent signals:
    // the WebSocket connected (or its anti-stuck fallback fired) and the
    // full post-login init (CompleteLogin incl. AfterLoggedIn) finished.
    // Dispatching APP_READY on either alone declares the UI interactive
    // while the other is still mutating it - a click landing during that
    // window dies on a nav node that React replaces mid-dispatch.
    WS_CONNECTED: "auth.ws_connected",
    INIT_COMPLETE: "auth.init_complete",
    // App-startup failure that is NOT a credentials problem: feature flag
    // timeout, settings-fetch failure, server-clock sync error, etc.
    // Distinct from LOGIN_ERROR (wrong password, MFA failure) so the
    // UI can show a generic "service unavailable" overlay rather than
    // a "wrong username or password" message.
    APP_INIT_FAILED: "auth.app_init_failed",
    // Consent gate: the user has not accepted the current terms, so the
    // gateway refuses every UI request. The app must not boot; it shows the
    // terms instead, and boots once they accept.
    TERMS_REQUIRED: "auth.terms_required",
    TERMS_ACCEPTED: "auth.terms_accepted",
    // The MFA recommendation is raised by the login screen the moment sign-in
    // returns, but the terms gate stands in front of it and the settings
    // fetches that run on accepting close any open modal. Remember it instead,
    // and raise it once the gate is open.
    MFA_NOTICE_DEFERRED: "auth.mfa_notice_deferred",
    MFA_NOTICE_SHOWN: "auth.mfa_notice_shown",
    // New terms were published while this user was signed in. Pushed over the
    // platform:terms channel every session is subscribed to.
    TERMS_PUBLISHED: "auth.terms_published",
};
